var map = {
	"./Central-mobile.jpg": 1124,
	"./Mandurah-mobile.jpg": 1125,
	"./North-mobile.jpg": 1126,
	"./South-mobile.jpg": 1127,
	"./default-mobile.jpg": 1128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1123;